var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.profile)?_c('v-container',[(_vm.stripeCustomerInitialized)?_c('div',[_c('payment-history')],1):_vm._e(),_c('profile-status')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }